/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, {Component} from 'react';
import {
    BrowserRouter as Router,
    Route,
    Routes
} from 'react-router-dom';

import AppRouter from './AppRouter';
import { ThemeProvider } from './common/styles/ThemeProvider';

import './styles/bootstrap.scss';
import './App.scss';

class App extends Component {
    render() {
        return (
            <ThemeProvider>
                <Router 
                    basename={"/"}
                    future={{
                        v7_startTransition: true,
                        v7_relativeSplatPath: true
                    }}
                >
                    <Routes>
                        <Route path="/*" element={<AppRouter />} />
                    </Routes>
                </Router>
            </ThemeProvider>
        );
    }
}

export default App;
